import styled from "styled-components";

export const ContentModal = styled.div`
  position: absolute;
  left: 25%;
  bottom: 30%;
  width: 483px;
  height: fit-content;
  max-width: 70%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  .MuiTypography-body1 {
    font-size: 14px;
  }
  @media only screen and (min-width: 769px) {
    left: 25%;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    left: 15%;
  }
  @media only screen and (max-width: 480px) {
    left: 15%;
  }
`;

export const CloseModal = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.black};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const ModalTitle = styled.label`
  font-size: 18px;
  color: ${({ theme }) => theme.neutral.black};
  font-weight: 600;
  position: absolute;
  left: 31px;
  top: 17px;
`;

export const ContentAlertText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ modalAlertTitle }) =>
    modalAlertTitle ? "#8be4bf" : "#f8d7d9"};
  width: 100%;
  height: 44px;
`;

export const TitleAlert = styled.div`
  color: ${({ theme }) => theme.primary.purple};
  font-size: 14px;
  font-weight: 500;
`;

export const ButtonConfirm = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  cursor: pointer;
  opacity: ${({ isDisabled }) => (isDisabled ? "0.4" : "1.0")};
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
  }
`;

export const TextModal = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  height: auto;
  overflow-y: visible;
  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ContentSelect = styled.div`
  display: grid;
  grid-auto-rows: 0.5fr 1fr;
  border-radius: 9px;
  margin-top: 1em;

  input {
    width: 100%;
    height: 30px;
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.secondaryGrayDarkOne};
  }
`;

export const SelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    fontSize: "14px",
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
      fontSize: "14px",
    };
  },
};
